import axios from 'axios';

const baseURL = 'api/Cuestionario';

async function getResultadoByCuestionario(idCuestionario, usuario) {
    const { data } = await axios.get(baseURL + "/GetResultado/" + idCuestionario,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function getActual(usuario) {
    const { data } = await axios.get(baseURL + "/actual?idUsuario=" + usuario.id + "&language=" + usuario.language,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function getHistorico(usuario) {
    const { data } = await axios.get(baseURL + "/historico?idUsuario=" + usuario.id,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function finalizar(usuario) {
    const { data } = await axios.get(baseURL + "/finalizar?id_usuario=" + usuario.id + "&language=" + usuario.language,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function getReport(usuario, idCuestionario, chartImage) {
    const parametros = {
        idUsuario: usuario.id,
        idCuestionario: idCuestionario,
        language: usuario.language,
        token: usuario.token,
        chartImage: chartImage
    }
    const { data } = await axios.post(baseURL + "/report",
        parametros
        , { responseType: 'blob' }
    );
    return data;
}
async function getReportParcial(usuario, idCuestionario, chartImage) {
    const parametros = {
        idUsuario: usuario.id,
        idCuestionario: idCuestionario,
        language: usuario.language,
        token: usuario.token,
        chartImage: chartImage
    }
    const { data } = await axios.post(baseURL + "/reportParcial",
        parametros
        , { responseType: 'blob' }
    );
    return data;
}

async function getReportEje(usuario, idCuestionario, idEje) {
    const parametros = {
        idUsuario: usuario.id,
        idCuestionario: idCuestionario,
        language: usuario.language,
        token: usuario.token,
        idEje: idEje
    }
    const { data } = await axios.post(baseURL + "/reportEje",
        parametros
        , { responseType: 'blob' }
    );
    return data;
}

async function getEjes(usuario) {
    const { data } = await axios.get(baseURL + "/temas?id_usuario=" + usuario.id + "&language=" + usuario.language,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function anularEje(usuario, idEje) {
    const { data } = await axios.delete(baseURL + "/anularEje?id_usuario=" + usuario.id + "&id_eje=" + idEje + "&language=" + usuario.language,
        {
            headers: {
                'token': usuario.token
            }
        }
    );
    return data;
}

async function activarEje(usuario, idEje) {
    const parametros = {
        id_eje: idEje,
        id_usuario: usuario.id,
        language: usuario.language,
        token: usuario.token
    }
    const { data } = await axios.post(baseURL + "/activarEje", parametros);
    return data;
}

async function nuevoConPerfilEmpresarial(usuario,
    nif,
    RazonSocialNombre,
    categoriaEmpresa,
    cnaePrincipal,
    cnaeDivisiones,
    comunidadAutonoma,
    provincia,
    municipio,
    cnaeSecundaria,
    cnaeSecundariaDivisiones
) {

    const parametros = {
        idUsuario: usuario.id,
        language: usuario.language,
        token: usuario.token,
        nif: nif,
        razon_social: RazonSocialNombre,
        id_categoria_empresa: categoriaEmpresa,
        id_CNAE_sector: cnaePrincipal,
        id_CNAE_division: cnaeDivisiones,
        id_comunidad_autonoma: comunidadAutonoma,
        id_provincia: provincia,
        id_municipio: municipio,
        id_CNAE_sector_secundario: cnaeSecundaria,
        id_CNAE_division_secundario: cnaeSecundariaDivisiones
    }
    const { data } = await axios.post(baseURL + "/nuevoConPerfilEmpresarial", parametros);
    return data;
}

export default { getResultadoByCuestionario, getActual, getHistorico, finalizar, getReport, getEjes, nuevoConPerfilEmpresarial, getReportEje, anularEje, activarEje, getReportParcial };